import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import * as tslib_1 from "tslib";
import _ from 'lodash';
import { GenericErrorResponseCode, DefaultAccountDetails } from '@tradingblock/types';
import { GetAccountsUrl, GetAccountDetailsUrl, AccountsSearchUrl, GetSubaccountsUrl, SearchAccountUpdatesUrl, GetAccountUpdateDetailsUrl, GetAccountManagementDetailsUrl } from '../constants';
import { getIdNumber } from '..';
import { dateStringOrUndefined } from '..';
var RequestHeaders = {
  headers: {
    Accept: 'application/json'
  }
};
export function accounts(api) {
  var _this = this;

  return {
    all: function all() {
      return api.authenticated().get(GetAccountsUrl, {}, RequestHeaders);
    },
    get: function get(acctId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var accountId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                accountId = getIdNumber(acctId);
                _context.next = 4;
                return api.authenticated().get(GetAccountsUrl, {
                  accountId: accountId
                }, RequestHeaders);

              case 4:
                return _context.abrupt("return", _context.sent);

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.warn('error requesting account by accountId', acctId);
                return _context.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: []
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));
    },
    subaccounts: function subaccounts(acctId) {
      var accountId = getIdNumber(acctId);
      return api.authenticated().get(GetSubaccountsUrl, {
        accountId: accountId
      }, RequestHeaders);
    },
    details: function details(acctId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var accountId;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accountId = getIdNumber(acctId);
                _context2.next = 4;
                return api.authenticated().get(GetAccountDetailsUrl, {
                  accountId: accountId
                }, RequestHeaders);

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2["catch"](0);
                console.warn('error requesting account details by accountId', acctId);
                return _context2.abrupt("return", {
                  responseCode: GenericErrorResponseCode,
                  payload: DefaultAccountDetails
                });

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 7]]);
      }));
    },
    search: function search(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var searchRequest, result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                searchRequest = Object.assign({}, request);
                _context3.next = 3;
                return api.authenticated().get(AccountsSearchUrl, searchRequest, RequestHeaders);

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    update: function update(acctId, request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var holder, result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                holder = request.holder ? request.holder : 0;
                _context4.next = 3;
                return api.authenticated().put("Accounts/UpdateAccount?accountId=".concat(acctId, "&holder=").concat(holder), request, RequestHeaders);

              case 3:
                result = _context4.sent;
                return _context4.abrupt("return", result);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    },
    getUpdate: function getUpdate(confirm) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return api.authenticated().get("Accounts/GetAccountUpdate?confirm=".concat(confirm), RequestHeaders);

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));
    },
    confirmUpdate: function confirmUpdate(confirm) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return api.authenticated().put("Accounts/ConfirmAccountUpdate?confirm=".concat(confirm), confirm, RequestHeaders);

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
    },
    getUserUpdates: function getUserUpdates(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var startDate, endDate, searchRequest;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                startDate = _.isNil(request.startDate) ? undefined : dateStringOrUndefined(request.startDate, 'YYYY-MM-DD');
                endDate = _.isNil(request.endDate) ? undefined : dateStringOrUndefined(request.endDate, 'YYYY-MM-DD');
                searchRequest = Object.assign({}, request, {
                  endDate: endDate,
                  startDate: startDate
                });
                _context7.next = 5;
                return api.authenticated().get(SearchAccountUpdatesUrl, searchRequest, RequestHeaders);

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    },
    getUserUpdateDetails: function getUserUpdateDetails(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var updateRequest;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                updateRequest = {
                  accountId: request.accountId,
                  updateId: request.id
                };
                _context8.next = 3;
                return api.authenticated().get(GetAccountUpdateDetailsUrl, updateRequest, RequestHeaders);

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    },
    getUserAccountDetails: function getUserAccountDetails(accountId) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return api.authenticated().get(GetAccountManagementDetailsUrl, accountId, RequestHeaders);

              case 2:
                return _context9.abrupt("return", _context9.sent);

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));
    },
    firmApproveUpdate: function firmApproveUpdate(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10() {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return api.authenticated().put("Accounts/FirmApproveAccountUpdate?accountId=".concat(request.accountId, "&updateId=").concat(request.updateId), request.request, RequestHeaders);

              case 2:
                return _context10.abrupt("return", _context10.sent);

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));
    },
    firmRejectUpdate: function firmRejectUpdate(request) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11() {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return api.authenticated().put("Accounts/FirmRejectAccountUpdate?accountId=".concat(request.accountId, "&updateId=").concat(request.updateId), request.request, RequestHeaders);

              case 2:
                return _context11.abrupt("return", _context11.sent);

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    },
    entitlements: function entitlements() {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return api.authenticated().get("/User/GetEntitlements", {}, RequestHeaders);

              case 2:
                return _context12.abrupt("return", _context12.sent);

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    }
  };
}